const DECIMAL_VALIDATOR = /^\s*-?\d*(?:\.\d{1,2})?\s*$/;

const PASSWORD_REGEX = /^(?=.*[A-ZÑ])(?=.*[#%&@?¿*])(.*[\d]){3}[A-Za-zñÑ\d#%&@?¿*]*$/;

const ID_CARD_REGEX = /^((([X-Z])|([LM])){1}([-]?)((\d){7})([-]?)([A-Z]{1}))|((\d{8})([-]?)([A-Z]))$/i;

export { DECIMAL_VALIDATOR, PASSWORD_REGEX, ID_CARD_REGEX };
